export function NoFallback<T>(): T {
  throw new Error(
    "Vue dependency injection failed. A developer should resolve this bug."
  );
}
